// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1326":"f70a4c5b239ece1ed79b","1590":"fb1380a1392cd5fb8378"}[chunkId] + ".css";
};